import i18next from 'i18next';
import { ICurrentData } from './OrderBarChart';

type Statuses = {
  created: number;
  success: number;
  canceled: number;
  cancel_by_admin: number;
  cancel_by_user: number;
  cancel_by_system: number;
};

type ChartDataItem = {
  all_count: number;
  statuses: Statuses;
};

type ChartDataType = [string, ChartDataItem];

export const orderChartOptions = (data: ChartDataType[]) => {
  return {
    layout: {
      padding: { top: 40 },
    },
    plugins: {
      datalabels: {
        anchor: 'end' as const,
        align: 'top' as const,
        offset: 5,
        color: '#000',
        font: {
          weight: 'bold' as const,
          size: 14,
        },
        formatter: (value: number) => (value === 0 ? '' : value),
      },
      legend: {
        position: 'top' as const,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            family: '',
            size: 14,
            weight: 500,
          },
          color: '#333',
          padding: 10,
          boxWidth: 8,
          boxHeight: 8,
        },
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          title: () => '',
          label: (context: any) => {
            const label = context.dataset.label || '';
            return `${label}`;
          },
          afterBody: (context: any) => {
            const dataIndex = context[0].dataIndex;
            const category = data[dataIndex][1];

            if (!category) return [];

            const { statuses, all_count } = category;

            return [
              '',
              `${i18next.t('total_orders')}: ${all_count}`,
              '',
              `${i18next.t('created')}: ${statuses.created}`,
              `${i18next.t('success')}: ${statuses.success}`,
              `${i18next.t('order_canceled')}: ${statuses.canceled}`,
              `${i18next.t('cancel_by_admin')}: ${statuses.cancel_by_admin}`,
              `${i18next.t('cancel_by_user')}: ${statuses.cancel_by_user}`,
              `${i18next.t('cancel_by_system')}: ${statuses.cancel_by_system}`,
            ];
          },
        },
        backgroundColor: '#000',
        titleColor: '#fff',
        bodyColor: '#fff',
        cornerRadius: 4,
        padding: 10,
      },
    },
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
      x: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };
};

export const currentOrderChartOptions = (data: ICurrentData[]) => {
  return {
    layout: {
      padding: { top: 20 },
    },
    plugins: {
      datalabels: {
        anchor: 'end' as const,
        align: 'top' as const,
        offset: 5,
        color: '#000',
        font: {
          weight: 'bold' as const,
          size: 14,
        },
        formatter: (value: number) => (value === 0 ? '' : value),
      },
      legend: {
        position: 'top' as const,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            family: '',
            size: 14,
            weight: 500,
          },
          color: '#333',
          padding: 10,
          boxWidth: 8,
          boxHeight: 8,
        },
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          title: () => '',
          label: (context: any) => {
            const label = context.dataset.label || '';
            return `${label}`;
          },
          afterBody: (context: any) => {
            const dataIndex = context[0].dataIndex;
            const category = data[dataIndex];

            if (!category) return [];

            const { statistic, all_count } = category.data;

            return [
              '',
              `${i18next.t('total_orders')}: ${all_count}`,
              '',
              `${i18next.t('created')}: ${statistic.created}`,
              `${i18next.t('success')}: ${statistic.success}`,
              `${i18next.t('order_canceled')}: ${statistic.canceled}`,
              `${i18next.t('cancel_by_admin')}: ${statistic.cancel_by_admin}`,
              `${i18next.t('cancel_by_user')}: ${statistic.cancel_by_user}`,
              `${i18next.t('cancel_by_system')}: ${statistic.cancel_by_system}`,
            ];
          },
        },
        backgroundColor: '#000',
        titleColor: '#fff',
        bodyColor: '#fff',
        cornerRadius: 4,
        padding: 10,
      },

      responsive: true,
      maintainAspectRatio: false,
    },
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
      x: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          color: '#4B465C80',
        },
        grid: {
          display: false,
        },
      },
    },
  };
};
